import { render, staticRenderFns } from "./RutaReconocerIndex.vue?vue&type=template&id=3b20bd14"
import script from "./RutaReconocerIndex.vue?vue&type=script&lang=js"
export * from "./RutaReconocerIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports